// extracted by mini-css-extract-plugin
module.exports = {"other_profiles":"UsersListingWrapper_other_profiles__3lnYB","other_profile_item":"UsersListingWrapper_other_profile_item__1LKBD"};